import React from 'react';
import { FileContext } from './context';
import useFileProvider from './use-file-provider';

export const FileProvider = ({ children }: { children: React.ReactNode }) => {
  const value = useFileProvider();
  return <FileContext.Provider value={value}>{children}</FileContext.Provider>;
};
export default FileProvider;
